export const REPORT_USER_LIST_SUCCESS = 'REPORT_USER_LIST_SUCCESS';
export const REPORT_USER_LIST_ERROR   = 'REPORT_USER_LIST_ERROR';